import React from 'react';
import classNames from 'classnames';
import { useTSState } from '../../TSContext';
const SpeedButton = ({ playbackRate }) => {
    const { state, setStateLocal } = useTSState();
    const isActive = playbackRate === state.playbackRate;
    return (React.createElement("button", { className: classNames({
            'ts-speed-player-btn-active': isActive,
            'ts-speed-player-btn': !isActive
        }), onClick: () => setStateLocal({ playbackRate }) },
        playbackRate,
        "x"));
};
export default SpeedButton;
